<ion-list *ngIf="isPageReady" [formGroup]="formGroup">
  <ion-item disabled class="time-item" lines="full" *ngIf="!notableActivityFormControlParams.dateTime.isHidden">
    <ion-label position="fixed">Date:</ion-label>
    <ion-datetime-button datetime="date">
      <ion-label *ngIf="!formGroup.value.dateTime" slot="date-target">Select Date</ion-label>
    </ion-datetime-button>
    <ion-modal [keepContentsMounted]="true">
      <ng-template>
        <ion-datetime id="date" showDefaultButtons presentation="date" formControlName="dateTime"></ion-datetime>
      </ng-template>
    </ion-modal>
  </ion-item>

  <ion-item lines="full" *ngIf="!notableActivityFormControlParams.dateTime.isHidden">
    <ion-label position="fixed">Time:</ion-label>
    <time-picker
      (onTimeSelect)="onTimeSelect($event)"
      [minInterval]="minInterval"
      [minTime]="notableActivityFormControlParams.dateTime.minValue | date: 'HH:mm'"
      [maxTime]="notableActivityFormControlParams.dateTime.maxValue | date: 'HH:mm'"
      [selectedDateTime]="formGroup.controls.dateTime.value"
      [timeZoneId]="timeZoneId"></time-picker>
    <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.dateTime)">{{ error }}</ion-note>
    <ion-note color="danger" *ngIf="!enclosingTimeRecord">You were not clocked in at this time.</ion-note>
  </ion-item>

  <ion-item lines="none" *ngIf="!notableActivities || notableActivities.length == 0; else notableActivitiesSelect">
    <ion-label mode="ios" position="stacked">What are you working on...</ion-label>
    <ion-textarea rows="4" formControlName="otherText" aria-placeholder="Other activity"></ion-textarea>
    <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.otherText)">{{ error }}</ion-note>
  </ion-item>
  <ng-template #notableActivitiesSelect>
    <ion-item lines="none">
      <div class="notable-activities">
        <ion-label mode="ios" position="stacked" class="notableActivityLabel">What are you working on...</ion-label>
        <div class="select" (click)="openNotableActivitiesModal()">
          <div text-wrap class="notableActivityLabel"
            >{{ formGroup.controls.text.value || 'Select an activity' }}
            <span>
              <ion-icon name="caret-down"></ion-icon>
            </span>
          </div>
        </div>
        <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.text)">{{ error }}</ion-note>
        <ion-textarea
          *ngIf="formGroup.controls.text.value && formGroup.controls.text.value.toLocaleLowerCase() === 'other'"
          rows="4"
          formControlName="otherText"
          aria-placeholder="Other activity"></ion-textarea>
        <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.otherText)">{{ error }}</ion-note>
      </div>
    </ion-item>
  </ng-template>
</ion-list>
